import React from 'react'
import {withStyles} from 'external/material'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'

const TransferListButton = withStyles(theme => ({
  root: {
    width: '50px',
    height: '50px',
    '&:hover': {
      transform: 'scale(1.02)'
    }
  },
  disabled: {
    opacity: 0.5
  },
}))(props => (
  <Grid item className="button">
    <Button
      variant="outlined"
      size="small"
      {...props}
    >
      {props.children}
    </Button>
  </Grid>
))

export {TransferListButton as default}
